query DocumentsChartData {
  kpiDocumentBreakdowns(first: 5, orderBy: UNUSED_DOCUMENT_COUNT_DESC) {
    nodes {
      id
      name
      unusedDocumentCount
      invoiceActiveCount
      invoiceEntryCount
      paymentActiveCount
      paymentEntryCount
    }
  }
}
